import { render } from "./SaveReportingMethod.vue?vue&type=template&id=2312b122"
import script from "./SaveReportingMethod.vue?vue&type=script&lang=js"
export * from "./SaveReportingMethod.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__